import classNames from 'classnames'
import { useEffect, useMemo, useRef, useState } from 'react'
import { SwiperSlide, Swiper } from 'swiper/react'
import Close from '../../assets/close-onboarding.svg?react'
import ArrowLeftSlideShow from '../../assets/left-slideshow-arrow.svg?react'
import ArrowRightSlideShow from '../../assets/right-slideshow-arrow.svg?react'
import Logo from '../../assets/wiki_logo.svg?react'
import Topbar from './Topbar'
import { useTranslation } from 'react-i18next'
import Profile from './Profile'
import { Navigation } from 'swiper/modules'
import { useDonationContext } from '../../context/DonationContext'
import { Modal } from 'react-bootstrap'
import { getActiveGeocontext } from '../../utils'
import Scraping from './Scraping'
import ScrapingOsm from './ScrapingOsm'
import ScrapingCommons from './ScrapingCommons'

export function SlidesPresentazioneDesktop({
  setPresentazione,
  isFromPageWiki,
}: {
  setPresentazione: (presentazione: boolean) => void
  isFromPageWiki?: boolean
}) {
  const [activeSlide, setActiveSlide] = useState<number>(0)
  const sliderRef = useRef<any>()
  const { t } = useTranslation()

  return (
    <div
      className="w-100 h-100"
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        zIndex: 12,
        backgroundColor: 'rgba(0,0,0,0.6)',
      }}
    >
      <Swiper
        slidesPerView={1}
        onSlideChange={(swiper) => {
          setActiveSlide(swiper.activeIndex)
        }}
        className="position-relative"
        // className="h-100 w-100"
        onSwiper={(swiper) => {
          sliderRef.current = swiper
        }}
        modules={[Navigation]}
        spaceBetween={20}
        navigation
        onInit={(swiper) => {
          swiper.slideTo(activeSlide, 0)
        }}
        style={{
          height:
            'calc(100% - var(--topbar-desktop-height) - var(--bottom-desktop-navigation-height) - 82px)',
          width: '60%',

          marginTop: 'calc(var(--topbar-desktop-height) + 16px)',
        }}
      >
        <SwiperSlide className={'position-relative'}>
          <div className={'SlideDesktop'}>
            <div className="d-flex justify-content-center align-items-center h-100 flex-column">
              <div>
                <Logo />
              </div>
              <div className="mt-4 TitleSlideDesktop">{t('GENERIC_WLM')}</div>
              <div className="mt-5 SubtitleSlideDesktop">
                {t('TUTORIAL_OPENING')}!
              </div>
              <div className="mt-4">{t('TUTORIAL_010_ALL_TEXT')}</div>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide className={'position-relative'}>
          <div className={'SlideDesktop'}>
            <div className="d-flex justify-content-center align-items-center h-100 flex-column">
              <div className="mt-2 SubtitleSlideDesktop">
                {t('GENERIC_COUNTRY')}
              </div>
              <div className="mt-4 mb-3">{t('TUTORIAL_020_ALL_TEXT')}</div>
              <img src={'/slides/desktop/slide2.svg'} alt="Slide2" />
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide className={'position-relative'}>
          <div className={'SlideDesktop'}>
            <div className="d-flex justify-content-center align-items-center h-100 flex-column">
              <div className="mt-2 SubtitleSlideDesktop">
                {t('TUTORIAL_030_ALL_TITLE')}
              </div>
              <div className="mt-4 text-center px-5">
                {t('TUTORIAL_030_ALL_TEXT')}
              </div>
              <div className="mt-1 px-5 text-center mb-2 ">
                {t('TUTORIAL_030_ALL_TEXT_2')}
              </div>
              <img
                src={'/slides/desktop/slide3.svg'}
                alt="Slide2"
                height={300}
              />
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide className={'position-relative'}>
          <div className={'SlideDesktop'}>
            <div className="d-flex justify-content-center align-items-center h-100 flex-column">
              <div className="mt-2 SubtitleSlideDesktop">
                {t('MPL_BOX_MAP')}
              </div>
              <div className="mt-4 text-center px-5">
                {t('TUTORIAL_040_ALL_TEXT')}
              </div>
              <div className="mt-1 px-5 text-center mb-2">
                {t('TUTORIAL_040_ALL_TEXT_2')}
              </div>
              <img
                src={'/slides/desktop/slide4.svg'}
                alt="Slide2"
                height={300}
              />
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide className={'position-relative'}>
          <div className={'SlideDesktop'}>
            <div className="d-flex justify-content-center align-items-center h-100 flex-column">
              <div className="mt-2 SubtitleSlideDesktop">
                {t('TUTORIAL_050_ALL_TITLE')}
              </div>
              <div className="mt-4 mb-3 text-center px-5">
                {t('TUTORIAL_050_ALL_TEXT')}
              </div>
              <img
                src={'/slides/desktop/slide5.svg'}
                alt="Slide2"
                height={300}
              />
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide className={'position-relative'}>
          <div className={'SlideDesktop'}>
            <div className="d-flex justify-content-center align-items-center h-100 flex-column">
              <div className="mt-2 SubtitleSlideDesktop">
                {t('GENERIC_LEGEND')}
              </div>
              <div className="mt-4 text-center px-5">
                {t('TUTORIAL_060_DSK_TEXT')}
              </div>
              <div className="mt-1 px-5 text-center mb-2 ">
                {t('TUTORIAL_060_DSK_TEXT_2')}
              </div>
              <img
                src={'/slides/desktop/slide6.svg'}
                alt="Slide2"
                height={300}
              />
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide className={'position-relative'}>
          <div className={'SlideDesktop'}>
            <div className="d-flex justify-content-center align-items-center h-100 flex-column">
              <div className="mt-2 SubtitleSlideDesktop">
                {t('TUTORIAL_070_DSK_TITLE')}
              </div>
              <div className="mt-4 text-center px-5">
                {t('TUTORIAL_070_DSK_TEXT')}
              </div>
              <div className="mt-1 px-5 text-center mb-1">
                {t('TUTORIAL_070_DSK_TEXT_2')}
              </div>
              <div className="mt-1 px-5 text-center mb-1">
                {t('TUTORIAL_070_DSK_TEXT_3')}
              </div>
              <img
                src={'/slides/desktop/slide7.svg'}
                alt="Slide2"
                height={300}
              />
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide className={'position-relative'}>
          <div className={'SlideDesktop'}>
            <div className="d-flex justify-content-center align-items-center h-100 flex-column">
              <div className="mt-2 SubtitleSlideDesktop">
                {t('TUTORIAL_080_ALL_TITLE')}
              </div>
              <div className="mt-4 mb-3 text-center px-5">
                {t('TUTORIAL_080_ALL_TEXT')}
              </div>
              <img
                src={'/slides/desktop/slide8.svg'}
                alt="Slide2"
                height={300}
              />
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide className={'position-relative'}>
          <div className={'SlideDesktop'}>
            <div className="d-flex justify-content-center align-items-center h-100 flex-column">
              <div>
                <Logo />
              </div>
              <div className="mt-4 TitleSlideDesktop">{t('GENERIC_WLM')}</div>
              <div className="mt-4">{t('TUTORIAL_090_ALL_TEXT')}</div>
              <div className="mt-5 SubtitleSlideDesktop">
                {t('TUTORIAL_CLOSING')}!
              </div>
            </div>
          </div>
        </SwiperSlide>
      </Swiper>
      <div
        onClick={() => {
          setPresentazione(false)
        }}
        className="button-close-slides-mobile pointer"
      >
        <Close />
      </div>
      <div className={'pagination-container-onboarding'}>
        <ArrowLeftSlideShow
          onClick={() => {
            if (activeSlide > 0) {
              sliderRef.current?.slidePrev()
            }
          }}
          className={classNames('me-3', {
            pointer: activeSlide > 0,
          })}
          fill={
            activeSlide > 0
              ? 'var(--colori-neutri-white)'
              : 'var(--colori-neutri-gray-2)'
          }
        />
        <div className={'current-slide-onboarding'}>{activeSlide + 1} / 9</div>
        <div
          className={classNames('ms-3', {
            pointer: activeSlide < 8,
          })}
        >
          <ArrowRightSlideShow
            onClick={() => {
              if (activeSlide < 8) {
                sliderRef.current?.slideNext()
              }
            }}
            fill={
              activeSlide < 8
                ? 'var(--colori-neutri-white)'
                : 'var(--colori-neutri-gray-2)'
            }
          />
        </div>
      </div>
    </div>
  )
}

export default function Layout({ children }: { children: React.ReactNode }) {
  const [presentazione, setPresentazione] = useState<boolean>(false)

  useEffect(() => {
    if (!localStorage.getItem('presentazione')) {
      setPresentazione(true)
      localStorage.setItem('presentazione', 'true')
    }
  }, [])

  const [scrapingOpen, setScrapingOpen] = useState<boolean>(false)
  const [scrapingOsmOpen, setScrapingOsmOpen] = useState<boolean>(false)
  const [scrapingCommonsOpen, setScrapingCommonsOpen] = useState<boolean>(false)
  const [profileOpen, setProfileOpen] = useState<boolean>(false)
  const { donationModal, setDonationModal } = useDonationContext()
  const activeGeocontext = getActiveGeocontext()
  const { i18n, t } = useTranslation()

  const donationText = useMemo(() => {
    if (!activeGeocontext) return ''
    if (
      activeGeocontext.donation_texts[i18n.language] &&
      activeGeocontext.donation_texts[i18n.language] !== ''
    ) {
      return activeGeocontext.donation_texts[i18n.language]
    }
    if (activeGeocontext.fallback_language_donation_intro) {
      const fallbackCode =
        activeGeocontext.fallback_language_donation_intro.code
      if (
        activeGeocontext.donation_texts[fallbackCode] &&
        activeGeocontext.donation_texts[fallbackCode] !== ''
      ) {
        return activeGeocontext.donation_texts[fallbackCode]
      }
    }
  }, [activeGeocontext, i18n.language])

  return (
    <div className="h-100 w-100">
      {presentazione && (
        <SlidesPresentazioneDesktop setPresentazione={setPresentazione} />
      )}
      <Topbar
        setScrapingOpen={setScrapingOpen}
        scrapingOpen={scrapingOpen}
        setProfileOpen={setProfileOpen}
        profileOpen={profileOpen}
        setScrapingOsmOpen={setScrapingOsmOpen}
        scrapingOsmOpen={scrapingOsmOpen}
        setScrapingCommonsOpen={setScrapingCommonsOpen}
        scrapingCommonsOpen={scrapingCommonsOpen}
      />
      <div className="block-content-desktop">{children}</div>
      {scrapingOpen && (
        <Scraping
          setScrapingOpen={setScrapingOpen}
          scrapingOpen={scrapingOpen}
        />
      )}
      {scrapingOsmOpen && (
        <ScrapingOsm
          setScrapingOsmOpen={setScrapingOsmOpen}
          scrapingOsmOpen={scrapingOsmOpen}
        />
      )}
      {scrapingCommonsOpen && (
        <ScrapingCommons
          setScrapingCommonsOpen={setScrapingCommonsOpen}
          scrapingCommonsOpen={scrapingCommonsOpen}
        />
      )}
      {profileOpen && (
        <Profile
          isOpenProfile={profileOpen}
          setIsOpenProfile={setProfileOpen}
        />
      )}
      {donationModal &&
        activeGeocontext?.enable_donations_text &&
        activeGeocontext.donations_link && (
          <Modal
            show={donationModal}
            onHide={() => setDonationModal(false)}
            className="modal-donation"
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title>{t('MENU_DONATIONS')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="">
                <div className="">
                  <div
                    dangerouslySetInnerHTML={{
                      __html:
                        donationText || ''
                    }}
                  ></div>
                  <p>
                    <a
                      className="btn-donate text-decoration-none"
                      href={activeGeocontext.donations_link}
                      target="_blank"
                    >
                      {t('DON_WIN_CMD_DONATE')}
                    </a>
                  </p>
                </div>
              </div>
            </Modal.Body>
          </Modal>
        )}
    </div>
  )
}
